export const onDropdownHeaderOpen = () => {
  const element = document.querySelector('html')!.style;

  element.removeProperty('overflow');
  element.removeProperty('padding-right');
};
